import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Form, Input, Select } from "antd";
import BankTransfer from "./components/BankTransfer";
import UPI from "./components/UPI";
import Paypal from "./components/Paypal";
import Crypto from "./components/Crypto";
import CashWithdraw from "./components/CashWithdraw";
import WithdrawRequest from "./WithdrawRequest";
import {
  GetCredentialsApi,
  GetWalletApi,
} from "../../../../api/request/wallet/withdraw";
import { DownOutlined } from "@ant-design/icons";

const WithdrawMobile = ({ setPaymentMethods }) => {
  const [form] = Form.useForm();
  const { userDetails } = useSelector((state) => state?.user);
  const [walletDetails, setWalletDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [step, setStep] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [credentials, setCredentials] = useState([]);

  const paymentGateways = [
    {
      name: "Bank Transfer",
      value: 1,
      fees: 0,
      processingTime: "1 H",
      paymentLogoUrl: "/assets/images/bank.png",
    },
    {
      name: "PayPal",
      value: 6,
      fees: 0,
      processingTime: "1 H",
      paymentLogoUrl: "/assets/images/paypal.png",
    },
    {
      name: "Crypto",
      value: 6,
      fees: 0,
      processingTime: "1 H",
      paymentLogoUrl: "/assets/images/crypto.png",
    },
    // {  
    //     name: "UPI",
    //     value: 2,
    //     fees: 0,
    //     processingTime: "1 H",
    //     paymentLogoUrl: "/assets/images/upi.png"
    // },
    // {
    //     name: "Paypal",
    //     value: 3,
    //     fees: 0,
    //     processingTime: "1 H",
    //     paymentLogoUrl: "/assets/images/paypal.png"
    // },
    // {
    //     name: "Crypto",
    //     value: 4,
    //     fees: 0.0,
    //     processingTime: "1 H",
    //     paymentLogoUrl: "/assets/images/crypto.png"
    // }
  ];

  const getWalletDetails = async () => {
    setIsLoading(true);
    try {
      const params = { RuleType: "Withdraw" };
      const { data } = await GetWalletApi(
        userDetails?.id,
        new URLSearchParams(params).toString()
      );
      if (data?.success) setWalletDetails(data?.data);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getCredentials = async () => {
    try {
      const { data } = await GetCredentialsApi();
      if (data?.success) {
        setCredentials(data?.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getWalletDetails();
    getCredentials();
  }, []);

  useEffect(() => {
    if (paymentGateways.length > 0 && !paymentMethod) {
      const bankTransfer = paymentGateways.find(pg => pg.name === "Bank Transfer") || paymentGateways[0];
      setPaymentMethod(bankTransfer);
      setPaymentMethods(bankTransfer);
    }
  }, [paymentGateways]);

  const validateAmount = (_, value) => {
    if (!value) {
      setStep(1);
      return Promise.reject(new Error("Please enter amount."));
    }

    if (Number(value) <= 0) {
      setStep(1);
      return Promise.reject(new Error("Please enter a valid amount."));
    }

    if (walletDetails?.isRuleActive) {
      if (amount < walletDetails?.minAmount) {
        setStep(1);
        return Promise.reject(
          new Error(`Amount must be at least $${walletDetails?.minAmount}.`)
        );
      }
      if (amount > walletDetails?.maxAmount) {
        setStep(1);
        return Promise.reject(
          new Error(`Amount cannot exceed $${walletDetails?.maxAmount}.`)
        );
      }
    }

    return Promise.resolve();
  };

  const handleSubmit = (values) => {
    if (values?.amount && values?.paymentMethod) setStep(2);
  };

  const resetAll = () => {
    form.resetFields();
    setAmount(0);
    setPaymentMethod(null);
    setStep(1);
    setIsRefresh(true);
  };

  const renderStep = () => {
    switch (paymentMethod?.name) {
      case "BankTransfer":
        return (
          <BankTransfer
            amount={amount}
            resetAll={resetAll}
            details={credentials?.bankDetails}
          />
        );
      case "Bank Transfer":
        return <BankTransfer amount={amount} resetAll={resetAll} />;
      case "PayPal":
        return <Paypal amount={amount} resetAll={resetAll} />;
      case "Crypto":
        return <Crypto amount={amount} resetAll={resetAll} />;
      case "Cash":
        return (
          <CashWithdraw
            amount={amount}
            resetAll={resetAll}
            details={credentials?.mobileNumbers}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-5">
      <div className="mb-4">
        <div className="relative">
          <Form
            form={form}
            layout="vertical"
            className="space-y-5"
            onFinish={handleSubmit}
          >
            <div>
              <label className="text-lg font-medium text-gray-700 block mb-2">Select Payment Method</label>
              <Select
                value={paymentMethod?.name}
                onChange={(value) => {
                  const selected = paymentGateways.find(
                    (pg) => pg.name === value
                  );
                  setPaymentMethod(selected);
                  setPaymentMethods(selected);
                }}
                className="w-full !bg-white rounded-xl"
                size="large"
                // suffixIcon={
                //   <div className="flex items-center justify-center h-full w-full">
                //     <DownOutlined className="text-gray-400 bg-[#F5F9FD] p-2.5 rounded-lg" />
                //   </div>
                // }
                placeholder="Select Payment Method"
                popupClassName="custom-select-dropdown"
                dropdownAlign={{ offset: [0, 0] }}
                dropdownStyle={{
                  borderRadius: "16px",
                  padding: "8px",
                  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                  border: "none",
                  marginTop: "-10px",
                }}
              >
                {paymentGateways.map((item) => (
                  <Select.Option
                    key={item?.id}
                    value={item?.name}
                    label={
                      <span className="primary font-semibold text-sm">
                        {item?.name}
                      </span>
                    }
                  >
                    <div className="flex items-center gap-2 py-1 px-2 rounded-lg">
                      <img
                        src={item?.paymentLogoUrl}
                        alt="Icon"
                        className="h-[30px] w-[30px] object-contain"
                      />
                      <span className={`font-semibold text-sm`}>
                        {item?.name}
                      </span>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </div>
            <Form.Item
              name="amount"
              label={
                <span className="text-lg text-gray-500 font-medium">
                  Amount In USD
                </span>
              }
              rules={[{ validator: validateAmount }]}
            >
              <Input
                type="number"
                placeholder="Amount in USD"
                size="large"
                onChange={(e) => setAmount(e?.target?.value)}
                className="py-3"
              />
            </Form.Item>
          </Form>
        </div>
      </div>

      {renderStep()}

      <WithdrawRequest isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
    </div>
  );
};

export default WithdrawMobile;
